/**
 * Fallback product images.
 *
 * ~30 products in the catalog (liquid cleaners in Kanister, wall
 * dispensers, soap cartridges, a budget toilet paper) have no photo.
 * Each has a generated, product-type-specific icon shipped with the
 * theme at assets/hygeon-product-<handle>.svg (same style as the
 * original placeholder-icon set). This script drops that icon into any
 * product card or product-page gallery that would otherwise render
 * empty / a generic placeholder — collection grids, search results,
 * recommendations, and the product detail page.
 *
 * It only ever acts when there is NO real image, so the moment a real
 * photo is added to a product in Admin, this becomes a no-op for it.
 * (The homepage On sale / Alle Produkte cards render the icon straight
 * from Liquid in snippets/hygeon-tabs-card.liquid — this script covers
 * everything else.)
 */
(function () {
  'use strict';

  // Products known to ship without a photo. Kept explicit so the script
  // never guesses — a handle not in here is left exactly as Horizon
  // rendered it.
  var NO_IMAGE = [
    'desinfektion-hygienereiniger-schnellwirkend-10l',
    'desinfektion-ultraschallbad-reiniger-6x1l',
    'desinfektion-flaechendesinfektion-5l',
    'reinigung-sport-turnhallenreiniger-10l',
    'reinigung-polster-teppichreiniger-10l',
    'reinigung-grundreiniger-sauer-10l',
    'reinigung-bodenreiniger-duft-10l',
    'reinigung-beschichtung-compete-10l',
    'reinigung-scheuermilch-12x1l',
    'reinigung-essigreiniger-10l',
    'reinigung-citro-allzweckreiniger-10l',
    'reinigung-alkoholreiniger-10l',
    'spender-falthandtuch-edelstahl-gebuerstet-vfalz',
    'spender-handtuchpapier-maxi-vfalz-schwarz',
    'spender-handtuch-interfold-mini-schwarz',
    'spender-falthandtuch-weiss-zinterfold',
    'spender-falthandtuch-edelstahl-vfalz-500',
    'spender-handtuchrolle-autocut-schwarz',
    'spender-handtuchrolle-sensor-schwarz',
    'spender-tp-maxi-schwarz-28cm',
    'spender-tp-maxi-2rollen-schwarz-23cm',
    'spender-tp-jumbo-schwarz-25cm',
    'spender-tp-metall-weiss-32cm',
    'spender-tp-einzelblatt-mini-schwarz',
    'spender-tp-edelstahl-matt-jumbo-28cm-b',
    'spender-tp-edelstahl-matt-jumbo-28cm-a',
    'papier-seifenpatrone-m-950ml',
    'papier-seifencreme-10l',
    'papier-schaumseife-mild-5l',
    'papier-toilettenpapier-budget-3lagig'
  ];
  var KNOWN = Object.create(null);
  NO_IMAGE.forEach(function (h) { KNOWN[h] = true; });

  var ATTR = 'data-hygeon-fallback-done';

  // Resolve the theme asset base from any already-loaded theme asset.
  function assetBase() {
    var scripts = document.querySelectorAll('script[src*="/cdn/shop/t/"], link[href*="/cdn/shop/t/"]');
    for (var i = 0; i < scripts.length; i++) {
      var u = scripts[i].src || scripts[i].href || '';
      var m = u.match(/^(.*\/cdn\/shop\/t\/\d+\/assets\/)/);
      if (m) return m[1];
    }
    return null;
  }
  var BASE = assetBase();

  function iconUrl(handle) {
    // Real supplier photo (plockgmbh.de) shipped as a theme asset, one per
    // handle: assets/hygeon-product-<handle>.jpg. One handle
    // (papier-toilettenpapier-budget-3lagig) has no Plock match and only
    // ships the generated .svg — makeImg() falls back to it on error.
    return BASE ? BASE + 'hygeon-product-' + handle + '.jpg' : null;
  }

  function handleFromLink(el) {
    var a = el.querySelector && el.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9\-]+)/i);
    return m ? m[1] : null;
  }

  function hasRealImage(scope) {
    var imgs = scope.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var src = imgs[i].currentSrc || imgs[i].getAttribute('src') || '';
      if (/\/cdn\/shop\/(files|products)\//.test(src)) return true;
    }
    return false;
  }

  function makeImg(handle, alt) {
    var url = iconUrl(handle);
    if (!url) return null;
    var img = document.createElement('img');
    img.src = url;
    img.alt = alt || '';
    img.loading = 'lazy';
    img.width = 400;
    img.height = 400;
    img.setAttribute('data-hygeon-fallback', '');
    img.style.objectFit = 'contain';
    // Fall back to the generated .svg for the one handle that has no photo.
    img.onerror = function () {
      this.onerror = null;
      this.src = url.replace(/\.jpg$/, '.svg');
    };
    return img;
  }

  /* ---------- product cards (collection / search / recommendations) ---------- */
  function processCard(card) {
    if (card.getAttribute(ATTR)) return;
    var handle = handleFromLink(card) ||
      (card.getAttribute('data-product-handle') || '');
    if (!handle || !KNOWN[handle]) { card.setAttribute(ATTR, '1'); return; }
    if (hasRealImage(card)) { card.setAttribute(ATTR, '1'); return; }

    // Find the media slot: a container that holds the placeholder / img.
    var slot =
      card.querySelector('.card-gallery, [class*="card-gallery"]') ||
      card.querySelector('.product-media-container') ||
      card.querySelector('[class*="media"]') ||
      card.querySelector('.placeholder-svg') ||
      card.querySelector('img');
    if (!slot) { card.setAttribute(ATTR, '1'); return; }

    var img = makeImg(handle, (card.querySelector('a[href*="/products/"]') || {}).textContent || '');
    if (!img) { card.setAttribute(ATTR, '1'); return; }
    img.setAttribute('data-hygeon-fallback', 'card');

    if (slot.tagName === 'IMG') {
      slot.replaceWith(img);
    } else {
      // Horizon renders a title-as-placeholder + a generic svg when a card
      // has no image — remove both so the icon isn't stacked under empty
      // space, then put the icon in as the gallery's own content.
      var junk = slot.querySelectorAll('.product-card-gallery__title-placeholder, .placeholder-svg, svg.placeholder-svg');
      junk.forEach(function (j) { j.remove(); });
      slot.insertBefore(img, slot.firstChild);
    }
    card.setAttribute(ATTR, '1');
  }

  function sweepCards(root) {
    (root || document).querySelectorAll(
      'product-card, .product-card, .card--product, .hygeon-tabs-card, [class*="hygeon-tabs-card-"], ' +
      '.resource-card__wrapper, [class*="resource-card"], product-component[view-event-payload]'
    ).forEach(function (el) {
      // don't double-process the main product component as a "card"
      if (el.classList.contains('product-information--media-none') &&
          !el.classList.contains('resource-card__wrapper')) return;
      processCard(el);
    });
  }

  /* ---------- product detail page ---------- */
  function processProductPage() {
    // The MAIN product component only — never a related-products /
    // recommendations card (those are handled as cards above).
    var candidates = document.querySelectorAll('.product-information--media-none');
    var comp = null;
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (c.classList.contains('resource-card__wrapper')) continue;
      if (c.closest('.resource-list, [class*="resource-list"], [class*="recommendation" i], [class*="recommended" i], slideshow-component, .product-recommendations')) continue;
      comp = c;
      break;
    }
    if (!comp || comp.getAttribute(ATTR)) return;

    var handle = null;
    try {
      var payload = comp.getAttribute('view-event-payload');
      if (payload) handle = (JSON.parse(payload).product || {}).handle || null;
    } catch (e) {}
    if (!handle && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      handle = window.ShopifyAnalytics.meta.product.handle;
    }
    if (!handle) {
      var m = location.pathname.match(/\/products\/([a-z0-9\-]+)/i);
      handle = m ? m[1] : null;
    }
    if (!handle || !KNOWN[handle]) { comp.setAttribute(ATTR, '1'); return; }
    if (hasRealImage(comp)) { comp.setAttribute(ATTR, '1'); return; }

    var img = makeImg(handle, (document.querySelector('h1') || {}).textContent || '');
    if (!img) { comp.setAttribute(ATTR, '1'); return; }

    var wrap = document.createElement('div');
    wrap.className = 'hygeon-fallback-product-media';
    wrap.appendChild(img);
    // Prepend inside the grid; keep Horizon's own class untouched so its
    // layout logic isn't disturbed — CSS positions this block itself.
    comp.insertBefore(wrap, comp.firstChild);
    comp.setAttribute(ATTR, '1');
  }

  function run(root) {
    sweepCards(root);
    processProductPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  // AJAX grids (filter / sort / paginate) re-render cards.
  var pending = false;
  var mo = new MutationObserver(function (records) {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var n = records[i].addedNodes[j];
          if (n.nodeType === 1) run(n);
        }
      }
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
